import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(value: number, format: string = '1.0-0'): string {
    if (value === null) {
      return '';
    } else {
      return (this.decimalPipe.transform(value, format) || '').toString().replace(/,/g, ' ');
    }
  }
}
